export const MODULE_NAME = 'vendor';
export const ACCESS_NAME = 'Vendors';
